import React, { Component } from "react";
import { CREDIT_CARD, ANNUAL_INTEREST, LOAN_AMOUNT, LOAN2_AMOUNT, TENORS } from "../utils/constants";
import { calculateWithReducingBalance, pmt, rate, roundTo, formatter, templater } from '../utils/helpers'
import { Slider, ApplyButton, AmountInput, TenorInput, TenorSlider } from './inputComponents';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import Container from '@material-ui/core/Container';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import SvgIcon from '@material-ui/core/SvgIcon';
import { mainColor } from '../utils/palette';
import { ReactComponent as Calculator } from '../assets/images/calculator.svg';
import { ReactComponent as CreditCardTwoTone } from '../assets/images/creditcard.svg';
import { ReactComponent as Lower } from '../assets/images/lower.svg';
import { ReactComponent as Logo } from '../assets/images/logo.svg';
export default class CreditCardCalculator extends Component {
  static DEFAULT_LOAN_AMOUNT = 200000
  static DEFAULT_TENOR = 60

  constructor(props) {
    super(props)
    this.state = {
      loanAmount: CreditCardCalculator.DEFAULT_LOAN_AMOUNT,
      focusingAmountInput: false,
      tenor: CreditCardCalculator.DEFAULT_TENOR
    }
    this.refreshInfo = this.refreshInfo.bind(this)
    this.listComponents = [
      {
        key: 'installment',
        type: 'currency',
        translate_key: "monthly_installment"
      }
	  /*
	  , {
        key: 'totalInterestPaid',
        type: 'currency',
        translate_key: "totalInterestPaid"
      }
	  */
    ]
	this.valueLabelFormat = this.valueLabelFormat.bind(this)
    this.tenorOptions = TENORS.map((e) => ({ value: e, label: (e==6||e==60?e+props.translations.CreditCardCalculator2.month:"") }))
  }

  refreshInfo() {

  }

  onFieldChange(field) {
    return function (e, v) {
      let value = v
      if (!value)
        value = e.target.value;
      if(!value){
        if(field == 'loanAmount'){
          value = LOAN2_AMOUNT.MIN
        }
      }

      this.setState({
        [field]: parseInt(value)
      }, () => {
        this.refreshInfo()
      })
    }.bind(this)
  }
  calculateDebtConsolidOffer(tenor, loanAmount, annualInterest) {
    const installment = pmt(annualInterest / 12, tenor, -loanAmount, 0, 0)
    return {
      tenor,
      installment,
      totalInterestPaid: installment * tenor - loanAmount
    }
  }

  valueLabelFormat(value) {
    return this.tenorOptions.findIndex((mark) => mark.value === value) + 1;
  }

  render() {
    const airstarOffer = this.calculateDebtConsolidOffer(this.state.tenor, this.state.loanAmount, ANNUAL_INTEREST.LOAN)
    const originalOffer = calculateWithReducingBalance(this.state.loanAmount, CREDIT_CARD.INTEREST_RATE, CREDIT_CARD.MIN_PAY_RATE, 50)
    const { translations } = this.props;
    const { focusingAmountInput } = this.state;

    return (
      <div className='calculator creditCard'>
        <Container className="calculatorBody">
          <Grid container className="header">
            <p>
			  <SvgIcon className='computer' viewBox="0 0 119 177" component={Calculator}/>
              {translations.CreditCardCalculator2.name}
            </p>
          </Grid>
          <Grid container direction="column" className="calculatorDetail">
            <Grid container direction="row" className='amountRow'>
              <Grid item xs={12} sm={6} className='inputLabel'>
                <label className='inputLabel'>{translations.CreditCardCalculator2.loanAmount}</label>
              </Grid>
              <Grid item xs={12} sm={6} style={{textAlign: 'right'}}>
                <AmountInput
                  startAdornment={< InputAdornment position='start'><span className='amountAdornment'>HKD</span></InputAdornment>}
                  disableUnderline={true}
                  onChange={this.onFieldChange('loanAmount')}
                  onFocus={()=>{this.setState({focusingAmountInput: true})}}
                  onBlur={() => {
                    let remainder = parseInt(this.state.loanAmount) % 1000
                    let newValue = this.state.loanAmount - remainder;
                    if (newValue > LOAN2_AMOUNT.MAX)
                      newValue = LOAN2_AMOUNT.MAX
                    if (newValue < LOAN2_AMOUNT.MIN)
                      newValue = LOAN2_AMOUNT.MIN
                    this.onFieldChange('loanAmount')(null, newValue)
                    this.setState({ focusingAmountInput: false })
                  }}
                  value={focusingAmountInput ? this.state.loanAmount : formatter('currency_short', this.state.loanAmount)}
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Slider
                defaultValue={CreditCardCalculator.DEFAULT_LOAN_AMOUNT}
                min={LOAN2_AMOUNT.MIN}
                step={1000}
                max={LOAN2_AMOUNT.MAX}
                value={this.state.loanAmount}
                onChange={this.onFieldChange('loanAmount')}
                marks={[{value: LOAN2_AMOUNT.MIN, label: "HKD2,000"}, {value: LOAN2_AMOUNT.MAX, label: "HKD1,000,000"}, ]}
              />
            </Grid>
			<br/>
            <Grid container direction="row" className='amountRow'>
              <Grid item xs={12} sm={6} className='inputLabel'>
                <label className='inputLabel'>{translations.CreditCardCalculator2.tenor}</label>
              </Grid>
              <Grid item xs={12} sm={6} style={{textAlign: 'right'}}>
                <TenorInput
				  disableUnderline={true}
                  onChange={this.onFieldChange('tenor')}
                  onBlur={() => {
                    if (!TENORS.includes(this.state.tenor)) {
                      this.onFieldChange('tenor')(null, TENORS[0])
                    }
                  }}
                  value={this.state.tenor}
                  endAdornment={<InputAdornment position='end'><span className='amountAdornment'>&nbsp;&nbsp;{translations.CreditCardCalculator2.month}</span></InputAdornment>}
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
				<TenorSlider
				  defaultValue={CreditCardCalculator.DEFAULT_TENOR}
				  valueLabelFormat={this.valueLabelFormat}
				  min={6}
				  max={60}
				  step={null}
				  valueLabelDisplay="off"
				  marks={this.tenorOptions}
				  onChange={this.onFieldChange('tenor')}
				  value={this.state.tenor}
				/>
            </Grid>
            <Grid
              container
              direction="column"
              className="creditCardInfoList"
            >
              {
                this.listComponents.map(({ key, type, translate_key, unit }) => (
                  <Grid
                    key={key}
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="center"
                    className='creditCardInfoItem'
                  >
                    <Grid item xs={6} style={{ textAlign: 'right' }}>
						  <div className="loanTitle">
							  <span className='infoValue airstarlogo'>
								  {translations.common[translate_key]}
							  </span>
						  </div>
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: 'left' }}>
						  <div className="loanResult">
						  {formatter(type, airstarOffer[key], unit)}
						  </div>
                    </Grid>
                  </Grid>
                ))
              }
            </Grid>
          </Grid>
        </Container>
      </div>
    )
  }
}
